import React from 'react';
import "./style.css"


export default function Dummy() {
   
  return (
    <div className='loadingg'>
    <section class="loading">
  <span class="loadWords">Loading...</span>
  <span class="loading__anim"></span>
</section>
    </div>
  )
}
